<template>
  <main class="create-job-profile-view d-flex flex-column h-100 bg-bgDefault">
    <Transition
      name="step-fade"
      mode="out-in"
    >
      <CreateJobProfileStep1
        v-if="store.step === 1"
        key="step1"
      />
      <CreateJobProfileStep2
        v-else-if="store.step === 2"
        key="step2"
      />
    </Transition>
  </main>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useCreateJobProfileWizard } from '@/stores/jobProfiles/createJobProfileWizard';
import CreateJobProfileStep1 from '@/components/jobProfiles/wizard/CreateJobProfileStep1.vue';
import CreateJobProfileStep2 from '@/components/jobProfiles/wizard/CreateJobProfileStep2.vue';

const route = useRoute();
const store = useCreateJobProfileWizard();

onMounted(() => {
  const jobCode = route.query['job-code'];
  const { title } = route.query;
  const { location } = route.query;

  if (jobCode) store.formJobCode = jobCode;
  if (title) store.formTitle = title;
  if (location) store.formLocation = location;
});

onUnmounted(() => {
  store.reset();
});
</script>

<style scoped>
.create-job-profile-view {
  min-width: 1140px;
  height: 100%;
  overflow: hidden;
}

.step-fade-enter-active,
.step-fade-leave-active {
  transition: opacity 0.15s ease;
}

.step-fade-enter-from,
.step-fade-leave-to {
  opacity: 0;
}
</style>
